import moment from 'moment';
function participantPlan(participant, billingSubscriptions, billingPlans) {
    const currentDate = moment().toISOString();
    let participantSubscription;
    let plan;

    if (billingSubscriptions) {
        participantSubscription = billingSubscriptions
            .filter(
                (sub) =>
                    (sub.consumerId === participant.id ||
                        sub.producerId === participant.id) &&
                    sub.status === 'ACTIVE'
            )
            .find(
                (sub) =>
                    sub.startDate < currentDate &&
                    (!sub.endDate || sub.endDate > currentDate)
            );
    }

    if (billingPlans && participantSubscription) {
        plan = billingPlans.find(
            (plan) => plan.id === participantSubscription.plan.id
        );
    }
    return plan;
}

export { participantPlan };
